import React from 'react';

const FormStrip = ({formName}) => {
    return(
        <div className="formStrip">
            <h3>{formName}</h3>
        </div>
    )
}
export default FormStrip